import { ContactFormData, ContactFormResponse } from '../types/contact';
import { config } from '../config/env';
import { retryFetch } from '../utils/api/retryClient';
import { APIError } from '../types/api';

// Mock API response for development
const mockApiResponse = async (data: ContactFormData): Promise<ContactFormResponse> => {
  // Simulate network delay
  await new Promise(resolve => setTimeout(resolve, 1000));
  
  // Log the submission for development
  console.info('Contact form submission:', {
    ...data,
    forwardTo: 'support@diversicoin.cash'
  });
  
  return {
    success: true,
    message: 'Message sent successfully'
  };
};

export async function submitContactForm(data: ContactFormData): Promise<ContactFormResponse> {
  try {
    // Use mock API in development
    if (import.meta.env.DEV) {
      return await mockApiResponse(data);
    }

    // Real API call for production
    const response = await retryFetch<ContactFormResponse>(config.contactApiEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...data,
        forwardTo: 'support@diversicoin.cash'
      })
    });

    return response;
  } catch (error) {
    console.error('Contact form submission error:', error);
    throw error instanceof APIError
      ? error
      : new APIError('Failed to send message. Please try again later.');
  }
}